<div style="min-height: 40vh;">
    <div [hidden]="!pageId">
        <app-page-block-renderer [pageId]="pageId" (loadPageBlocksEvent)="isParsedPage = false;"
            [initializationPage]="initializationPage">
        </app-page-block-renderer>
    </div>
    <div *ngIf="!pageId" class="d-flex justify-content-center align-items-center">
        <app-loading></app-loading>
    </div>
</div>